import { FeatureSwitch } from '@if/core/types'
import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import configApi from '@src/data/api/config/config-api'
import { AxiosInstance } from 'axios'
import type { TRootState } from '..'
import allApi from '../../api'
import { makeSave } from '../effects/standard-side-effects'
import { appActions, UPDATE_FEATURE_SWITCH } from './app-store'

const appStoreEffects = {
  initialize: () => {
    return async (
      apiClient: AxiosInstance,
      dispatch: ThunkDispatch<TRootState, undefined, UnknownAction> /* select: TypedUseSelectorHook<TRootState>, */,
    ): Promise<void> => {
      // log api is loading
      dispatch(appActions.setInitializing(true))

      // perform actual request
      await Promise.all([
        configApi
          .getValueList(apiClient, { listId: 'CreditRefusalReasons' })
          .then((msg) => dispatch(appActions.setCreditRefusalReasons(msg))),
        configApi.getValueList(apiClient, { listId: 'Tags' }).then((msg) => dispatch(appActions.setMerchantTags(msg))),
        configApi.getTerritories(apiClient).then((msg) => dispatch(appActions.setTerritories(msg))),
        configApi.getProductProviders(apiClient).then((msg) => dispatch(appActions.setProductProviders(msg))),
        configApi.getEnum(apiClient, {}).then((msg) => dispatch(appActions.setEnums(msg))),
        configApi.getDocumentTypes(apiClient, {}).then((msg) => dispatch(appActions.setDocumentTypes(msg))),
        configApi.getFinancingConfigs(apiClient, {}).then((msg) => dispatch(appActions.setFinancingConfigs(msg))),
        configApi
          .getProvinceConfigurations(apiClient, {})
          .then((msg) => dispatch(appActions.setProvinceConfigurations(msg))),
        configApi.getTaskTypes(apiClient, {}).then((msg) => dispatch(appActions.setTaskTypes(msg))),
        configApi
          .getIFinanceHolidays(apiClient, { year: new Date().getFullYear().toString() })
          .then((msg) => dispatch(appActions.setHolidays(msg))),
        configApi.getAllFeatureSwitches(apiClient, {}).then((msg) => dispatch(appActions.setFeatureSwitches(msg))),
      ])
      dispatch(appActions.setInitializing(false))
      return Promise.resolve()
    }
  },
  updateFeatureSwitch: (data: FeatureSwitch) =>
    makeSave<FeatureSwitch>(
      UPDATE_FEATURE_SWITCH,
      allApi.config.updateFeatureSwitch,
      appActions.setFeatureSwitch,
      data,
    ),
}

export default appStoreEffects
